import { useState } from "react"

const useToggleValue = initialState => {
    const [state, setState] = useState(initialState)
    return [state, () => setState(!state), setState]
}

export default useToggleValue